import { useTranslation } from 'react-i18next';

import { OpBlurbPage } from 'new-components/OpBlurbPage/OpBlurbPage';

import accessCover from '../../assets/partner-access-blurb-cover.png';
import { ACCESS_NATIVE_APP_ID } from '../../constants/native-apps';
import { NativeAppIcon } from '../CustomerPage/components/NativeAppIcon/NativeAppIcon';

export default () => {
  const { t } = useTranslation();

  const content = [
    t(
      'Our complete, cloud-based access control system is fast, flexible and future-proof with reliable mobile capabilities and intuitive access control software.',
    ),
  ];

  return (
    <OpBlurbPage
      title={t('Alta Access')}
      coverImage={accessCover}
      avatarComponent={<NativeAppIcon nativeAppId={ACCESS_NATIVE_APP_ID} />}
      content={content}
      externalLink="https://security.avigilon.com/alta-access-partner"
    />
  );
};
